import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import CalendarIcon from "../../Assets/img/calendar.png";
import "./Blog.css";
import Select from "react-select";
import API from "../Service/Baseservice";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const BlogView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const blog = location.state?.blog;
    const page = location.state?.page || 1;
    const [formData, setFormData] = useState({
        author_name: "",
        heading: "",
        description: "",
        blog_date: "",
        blog_image: "",
    });

    const [imagePreview, setImagePreview] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);

    useEffect(() => {
        if (!blog) {
            alert("No blog data found. Redirecting...");
            navigate("/blog");
            return;
        }

        setFormData({
            author_name: blog.author_name || "",
            heading: blog.heading || "",
            description: blog.description || "",
            blog_date: blog.blog_date?.split(" ")[0] || "",
            blog_image: blog.blog_image || "",
        });

        if (blog.blog_image?.includes("http")) {
            setImagePreview(blog.blog_image);
        } else if (blog.blog_image) {
            setImagePreview(
                `http://dev-service.asraimmigration.ca/backend_service/uploads/blogs/${blog.blog_image}`
            );
        } else {
            setImagePreview(null);
        }

        if (blog.blog_tag_id) {
            let tagIds = [];
            try {
                tagIds = JSON.parse(blog.blog_tag_id);
            } catch (err) {
                console.error("Error parsing blog_tag_id:", err);
            }

            if (Array.isArray(tagIds) && tagIds.length > 0) {
                API.post("blogtag_list/condition", {})
                    .then((res) => {
                        const allTags = res?.data?.data?.data || [];
                        const matched = allTags
                            .filter((tag) => tagIds.includes(tag.blog_tag_id))
                            .map((tag) => ({
                                value: tag.blog_tag_id,
                                label: tag.blogtag,
                            }));
                        setSelectedTags(matched);
                    })
                    .catch((err) => {
                        console.error("Failed to fetch tags:", err);
                    });
            }
        }
    }, [blog, navigate]);

    return (
        <div className="blogadd-container">
            {/* Header */}
            <div className="blogadd-header">
                <h2 className="blogadd-title">View Blog</h2>
                <div className="header-buttons">
                    <button
                        onClick={() => navigate("/blog", { state: { page } })}
                        className="cancel-btn "
                        style={{ marginRight: "25px" }}
                    >
                        Back
                    </button>
                </div>
            </div>

            {/* Form Wrapper */}
            <div className="blogadd-form-wrapper">
                {/* Left Side */}
                <div className="blogadd-left-card">
                    <div className="upload-section" style={{ textAlign: "left" }}>
                        <label>Blog Image</label>
                        <div className="upload-box">
                            {imagePreview ? (
                                <img src={imagePreview} alt="Preview" className="preview-img" />
                            ) : (
                                <p>No image available</p>
                            )}
                        </div>
                    </div>

                    <div className="form-group2">
                        <label>Author Name</label>
                        <input
                            type="text"
                            name="author_name"
                            value={formData.author_name || ""}
                            readOnly
                        />
                    </div>

                    <div className="form-group2">
                        <label>Date</label>
                        <div className="date-wrapper1">
                            <input
                                type="date"
                                name="blog_date"
                                value={formData.blog_date || ""}
                                readOnly
                            />
                            <img
                                src={CalendarIcon}
                                alt="Calendar"
                                className="calendar-blog-icon"
                            />
                        </div>
                    </div>
                </div>

                {/* Right Side */}
                <div className="blogadd-right-card">
                    <div className="form-group">
                        <label className="description-label">Heading</label>
                        <input
                            type="text"
                            name="heading"
                            value={formData.heading || ""}
                            readOnly
                        />
                    </div>

                    {/* Read-only Tags */}
                    <div className="form-group">
                        <label className="description-label">Tags</label>
                        <Select
                            isMulti
                            isDisabled
                            value={selectedTags}
                            placeholder="No tags"
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    borderColor: "#ccc",
                                    backgroundColor: "#f9f9f9",
                                    boxShadow: "none",
                                    width: "100%",
                                }),
                            }}
                        />
                    </div>

                    <div className="form-group">
                        <label className="description-label">Description</label>
                        <div

                        >
                            <CKEditor
                                editor={ClassicEditor}
                                data={formData.description || ""}
                                disabled={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogView;
